export default "__VITE_ASSET__2tO2OOCl__"